/**
 * Private module reserved for @coursera/cds-core package.
 */

import { createSizedSvgIcon } from '@core/utils';

import { CHECKBOX_ICON_SIZE } from './getCheckboxInputCss';

export default createSizedSvgIcon(
  'CheckboxUncheckedIcon',
  {
    large: (
      <rect
        fill="inherit"
        height="18"
        rx="3.3332"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.8667"
        width="18"
        x="1"
        y="1"
      />
    ),
  },
  CHECKBOX_ICON_SIZE
);
